import {
  Avatar,
  Chip,
  Grid,
  Stack,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as CONST from '../../../../constants/FieldsConst';
import { formatDNI, textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import * as ROUTES from '../../../../router/Routes';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { deleteUsuEntidadesAction } from '../../../usuario/usu_entidades/UsuEntidadesAction';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allEstudiantesAction,
  oneEstudiantesAction,
  setActivoEstudiantesAction,
  updateEstatusEstudianteAction,
} from '../EstudiantesAction';
import { PARAMS_ESTUDIANTES, SELECTS_ESTUDIANTES } from '../EstudiantesReducer';
import DetalleExpandeEstudiantes from './DetalleExpandeEstudiantes';

let intervalSearch = null;

const ListadoEstudiantes = ({ setOpenModalForm, qrRef = [] }) => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);
  const seccionesStore = Redux.useSelector((state) => state.secciones);

  const [loading, setLoading] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);

  async function all(payload) {
    await allEstudiantesAction(dispatch, payload);
  }

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...estudiantesStore.params,
        idEntidad: entidadesStore.activo.id,
        idPeriodoAcademico: entidadesStore.ajustes?.periodoAcademico?.id,
        idSeccion:
          seccionesStore.all.length > 0 ? seccionesStore.all[0].id : null,
      };

      dispatch({ type: PARAMS_ESTUDIANTES, payload });
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rows = [];

    const listado = estudiantesStore.all.sort((a, b) => {
      // Validar si tienen sección asignada
      const aHasSection =
        a.matricula?.secciones && a.matricula.secciones.length > 0;
      const bHasSection =
        b.matricula?.secciones && b.matricula.secciones.length > 0;

      // Si uno tiene sección y otro no, el que tiene sección va primero
      if (aHasSection && !bHasSection) return -1;
      if (!aHasSection && bHasSection) return 1;

      // Si ninguno tiene sección, comparar por DNI
      if (!aHasSection && !bHasSection) {
        return a.usuario.perfil.dni - b.usuario.perfil.dni;
      }

      // Si ambos tienen sección, comparar por nivel académico
      const nivelComparison =
        a.matricula.secciones[0].seccion.nivelAcademico.nivelAcademico.id -
        b.matricula.secciones[0].seccion.nivelAcademico.nivelAcademico.id;
      if (nivelComparison !== 0) return nivelComparison;

      // Si nivel es igual, comparar por sección
      const seccionComparison =
        a.matricula.secciones[0].seccion.id -
        b.matricula.secciones[0].seccion.id;
      if (seccionComparison !== 0) return seccionComparison;

      // Si sección es igual, comparar por DNI
      return a.usuario.perfil.dni - b.usuario.perfil.dni;
    });

    listado.forEach((el) => {
      rows.push({
        ...el,
        dni: `${el.usuario.perfil.tipoDni}-${formatDNI(el.usuario.perfil.dni)}`,
        nombre: {
          nombre: `${el.usuario.perfil.papellido} ${
            el.usuario.perfil.sapellido ? el.usuario.perfil.sapellido : ''
          } ${el.usuario.perfil.pnombre} ${
            el.usuario.perfil.snombre ? el.usuario.perfil.snombre : ''
          }`,
          correo: el.usuario.correo,
        },
        foto: el.usuario.perfil.avatar,
        matricula: {
          matricula: el.matricula?.nroRegistro,
          seccion:
            el.matricula?.secciones && el.matricula.secciones.length > 0
              ? el.matricula.secciones[0].seccion.nombre
              : null,
          carrera:
            el.matricula?.secciones && el.matricula.secciones.length > 0
              ? el.matricula.secciones[0].seccion.carrera?.carrera?.abrev
              : null,
          nivel:
            el.matricula?.secciones && el.matricula.secciones.length > 0
              ? el.matricula.secciones[0].seccion.nivelAcademico?.nivelAcademico
                  .abrev
              : null,
          turno:
            el.matricula?.secciones && el.matricula.secciones.length > 0
              ? el.matricula.secciones[0].seccion.turno
              : null,
        },
        estatus: el.estatus?.nombre,
        actions: el,
      });
    });
    setRows(rows);
  }, [estudiantesStore.all]);

  const _onDeleteHandler = async () => {
    setLoading(true);
    await deleteUsuEntidadesAction(
      { dispatch, notify, isEstudiantes: true },
      estudiantesStore.activo.id,
      estudiantesStore.params,
    );
    setOpenModalDelete(false);
    setLoading(false);
  };

  function getDataStore(id) {
    return estudiantesStore.all.find((el) => el.id === id);
  }

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.foto.name,
      label: CONST.foto.label,
      width: '10%',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Avatar
              alt={value}
              sx={{ width: 60, height: 60 }}
              src={getFilesArchivos(value)}
            />
          );
        },
      },
    },
    {
      name: CONST.dni.name,
      label: CONST.dni.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <NameComponent>{value}</NameComponent>;
        },
      },
    },
    {
      name: CONST.nombre.name,
      label: 'Apellidos y Nombres',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <NameComponent
                onClick={async () => {
                  await setActivoEstudiantesAction(
                    dispatch,
                    tableMeta.rowData[6],
                  );
                  await oneEstudiantesAction(dispatch, tableMeta.rowData[0]);
                  history.push(ROUTES.panelEstudiantes.to);
                }}
              >
                {value.nombre}
              </NameComponent>
              <Typography>{value.correo}</Typography>
            </>
          );
        },
      },
    },
    {
      name: CONST.matricula.name,
      label: CONST.matricula.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          if (!value.matricula) {
            return <Chip color="error" size="small" label="Sin matrícula" />;
          }

          if (!value.seccion) {
            return (
              <Stack direction="column">
                <NameComponent>{value.matricula}</NameComponent>
                <Chip
                  color="warning"
                  size="small"
                  label="Sin sección asignada"
                />
              </Stack>
            );
          }

          return (
            <Stack direction="column">
              <NameComponent>{value.matricula}</NameComponent>
              <Typography variant="caption">
                {value.nivel}, {value.carrera ? `${value.carrera},` : ''}{' '}
                <strong>Sección:</strong> {value.seccion}
              </Typography>
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={
                  value === 'ACTIVO'
                    ? 'success'
                    : value === 'BLOQUEADO'
                    ? 'error'
                    : 'warning'
                }
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const estudiante = estudiantesStore.all.find(
            (el) => el.id === value.id,
          );
          return (
            <Stack direction="row">
              <BotonComponent
                click={async () => {
                  await setActivoEstudiantesAction(dispatch, value);
                  await oneEstudiantesAction(dispatch, value.id);
                  history.push(ROUTES.panelEstudiantes.to);
                }}
                icon
                size="medium"
                transparentBg
                dashboardIcon
                tooltip="Panel de gestión"
              />
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onActivar={
                  [2, 6].includes(estudiante?.estatus?.id)
                    ? async () => changedEstatus(estudiante?.id, 1)
                    : null
                }
                onBloquear={
                  estudiante?.estatu?.id === 1
                    ? async () => changedEstatus(estudiante?.id, 2)
                    : null
                }
                onDelete={async () => {
                  const data = getDataStore(estudiante?.id);
                  await setActivoEstudiantesAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
                onDownload={() => {
                  window.open(value.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  async function changedEstatus(idEstudiante, idEstatus) {
    setLoading(true);
    await updateEstatusEstudianteAction(
      { dispatch, notify },
      {
        idEstudiante,
        idEstatus,
      },
      estudiantesStore.params,
    );
    setLoading(false);
  }

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: estudiantesStore.params.limit,
    count: estudiantesStore.pagination?.totalItems ?? 0,
    page: estudiantesStore.pagination?.currentPage - 1 ?? 1,
    rowsPerPageOptions: [25, 60, 100, 200, 500, 700, 1000],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: false,
    expandableRows: true,
    rowSelectionModel: rowSelectionModel,
    onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
      setRowSelectionModel(allRowsSelected);
      const selectedUsers = allRowsSelected.map(
        (row) => estudiantesStore.all[row.index].id, // solo el id
      );
      dispatch({ type: SELECTS_ESTUDIANTES, payload: selectedUsers });
    },
    onClearSelection: () => {
      setRowSelectionModel([]);
      dispatch({ type: PARAMS_ESTUDIANTES, payload: [] });
    },
    renderExpandableRow: (rowData, rowMeta) => {
      const data = estudiantesStore.all.find(({ id }) => id === rowData[0]);
      const colSpan = rowData.length + 1;
      return (
        data && (
          <TableRow>
            <TableCell colSpan={colSpan}>
              <DetalleExpandeEstudiantes
                data={data}
                qrRef={qrRef[`codeqr${data.id}`]}
              />
            </TableCell>
          </TableRow>
        )
      );
    },
    serverSide: true,
    onSearchChange: (searchQuery) => {
      if (searchQuery) {
        clearTimeout(intervalSearch);
        intervalSearch = setTimeout(() => {
          const payload = {
            ...estudiantesStore.params,
            q: searchQuery,
          };
          dispatch({ type: PARAMS_ESTUDIANTES, payload });
          all(payload);
        }, 800);
      }
    },
    onSearchClose: () => {
      const payload = {
        ...estudiantesStore.params,
        q: null,
        page: 1,
      };
      dispatch({ type: PARAMS_ESTUDIANTES, payload });
      all(payload);
    },
    onChangePage: async (currentPage) => {
      const payload = {
        ...estudiantesStore.params,
        page: currentPage + 1,
      };
      dispatch({
        type: PARAMS_ESTUDIANTES,
        payload,
      });
      all(payload);
    },
    onChangeRowsPerPage: async (numberOfRows) => {
      const payload = {
        ...estudiantesStore.params,
        limit: numberOfRows,
        page: 1,
      };
      dispatch({
        type: PARAMS_ESTUDIANTES,
        payload,
      });
      all(payload);
    },
  };

  return (
    <Grid container spacing={1}>
      <Grid item md={12} sx={{ position: 'relative' }}>
        <LoadingWidget isLoading={estudiantesStore.loadingAll || loading} />
        <MUIDataTable
          title={`Listado de ${
            estudiantesStore.pagination?.totalItems ?? 0
          } registros`}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {estudiantesStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            <strong>Estudiante: </strong> <br />
            {`${estudiantesStore.activo.usuario.perfil.pnombre} ${
              estudiantesStore.activo.usuario.perfil.snombre
                ? estudiantesStore.activo.usuario.perfil.snombre
                : ''
            } ${estudiantesStore.activo.usuario.perfil.papellido} ${
              estudiantesStore.activo.usuario.perfil.sapellido
                ? estudiantesStore.activo.usuario.perfil.sapellido
                : ''
            }`}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoEstudiantes;
